import React from 'react';
import { components, type MenuListProps } from 'react-select';
import { List, type RowComponentProps } from 'react-window';

const optionHeight = 50;

interface RowData {
  items: React.ReactNode[];
}

const MenuList = <Option, IsMulti extends boolean>(
  properties: MenuListProps<Option, IsMulti>,
): React.ReactElement | null => {
  const { children } = properties;

  let items: React.ReactNode[] = [];

  if (Array.isArray(children)) {
    items = children as React.ReactNode[];
  } else if (children) {
    items = [children];
  }

  const itemCount = items.length;

  return (
    <components.MenuList {...properties}>
      <List rowComponent={RowComponent} rowCount={itemCount} rowHeight={optionHeight} rowProps={{ items }} />
    </components.MenuList>
  );
};

function RowComponent({ index, items, style }: RowComponentProps<RowData>): React.ReactElement {
  // eslint-disable-next-line react/forbid-dom-props -- required by react-window
  return <div style={style}>{items[index]}</div>;
}

export default MenuList;
